import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.promise.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState } from 'react';
import { Button, Form, Input, Icon, useUser } from 'components';
import { formContainer, submitButtonContainer, loginHeader, loginFooter, loginFormAnimated } from '../styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Login = function Login() {
  var _useUser = useUser(),
      login = _useUser.login,
      verify2fa = _useUser.verify2fa;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      twoFactorToken = _useState2[0],
      setTwoFactorToken = _useState2[1];

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(_ref) {
      var values, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              values = _ref.values;
              _context.next = 3;
              return login(values);

            case 3:
              res = _context.sent;
              if (res !== null && res !== void 0 && res.two_factor_required) setTwoFactorToken(res.two_factor_token);

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleVerify2fa = function handleVerify2fa(_ref3) {
    var values = _ref3.values;
    return verify2fa({
      two_factor_token: twoFactorToken,
      two_factor_code: values.two_factor_code
    });
  };

  if (twoFactorToken) {
    return ___EmotionJSX("div", {
      css: formContainer
    }, ___EmotionJSX("div", {
      className: "login-card"
    }, ___EmotionJSX("div", {
      css: loginHeader
    }, ___EmotionJSX("div", {
      className: "login-icon"
    }, ___EmotionJSX(Icon, {
      iconName: "las la-lock"
    })), ___EmotionJSX("h4", null, "\u041A\u043E\u0434 \u0437\u0430 \u0441\u0438\u0433\u0443\u0440\u043D\u043E\u0441\u0442"), ___EmotionJSX("p", null, "\u0412\u044A\u0432\u0435\u0434\u0435\u0442\u0435 \u043A\u043E\u0434\u0430 \u043E\u0442 \u0432\u0430\u0448\u0435\u0442\u043E \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u0435")), ___EmotionJSX(Form, {
      onSubmit: handleVerify2fa
    }, ___EmotionJSX(Input, {
      required: true,
      formId: "two_factor_code",
      placeholder: "\u041A\u043E\u0434 \u0437\u0430 \u043F\u043E\u0442\u0432\u044A\u0440\u0436\u0434\u0435\u043D\u0438\u0435"
    }), ___EmotionJSX("div", {
      css: submitButtonContainer
    }, function (_ref4) {
      var onSubmit = _ref4.onSubmit;
      return ___EmotionJSX(Button, {
        fullWidth: true,
        onClick: function onClick() {
          return onSubmit();
        }
      }, "\u041F\u043E\u0442\u0432\u044A\u0440\u0434\u0438");
    }))));
  }

  return ___EmotionJSX("div", {
    css: formContainer
  }, ___EmotionJSX("div", {
    className: "login-card"
  }, ___EmotionJSX("div", {
    css: loginHeader
  }, ___EmotionJSX("div", {
    className: "login-icon"
  }, ___EmotionJSX(Icon, {
    iconName: "las la-wallet"
  })), ___EmotionJSX("h4", null, "\u0414\u043E\u0431\u0440\u0435 \u0434\u043E\u0448\u043B\u0438"), ___EmotionJSX("p", null, "\u0412\u043B\u0435\u0437\u0442\u0435 \u0432 LendMate \u0430\u043A\u0430\u0443\u043D\u0442\u0430 \u0441\u0438")), ___EmotionJSX(Form, {
    onSubmit: handleSubmit
  }, ___EmotionJSX("div", {
    css: loginFormAnimated
  }, ___EmotionJSX(Input, {
    required: true,
    formId: "email",
    placeholder: "\u0418\u043C\u0435\u0439\u043B"
  }), ___EmotionJSX(Input, {
    required: true,
    type: "password",
    formId: "password",
    placeholder: "\u041F\u0430\u0440\u043E\u043B\u0430"
  }), ___EmotionJSX("div", {
    css: submitButtonContainer
  }, function (_ref5) {
    var onSubmit = _ref5.onSubmit;
    return ___EmotionJSX(Button, {
      fullWidth: true,
      onClick: function onClick() {
        return onSubmit();
      }
    }, "\u0412\u043B\u0435\u0437");
  }))), ___EmotionJSX("div", {
    css: loginFooter
  }, ___EmotionJSX("span", null, "LendMate \xA9 ", new Date().getFullYear()))));
};

export default Login;